/**
 * AiSparkle2Icon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AiSparkle2IconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.667 5.333A9.054 9.054 0 0 0 22 13.667 9.054 9.054 0 0 0 13.667 22a9.054 9.054 0 0 0-8.334-8.333 9.054 9.054 0 0 0 8.334-8.334M6.167 2a4.53 4.53 0 0 0 4.166 4.167 4.53 4.53 0 0 0-4.166 4.166A4.53 4.53 0 0 0 2 6.167 4.53 4.53 0 0 0 6.167 2" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AiSparkle2Icon = makeIcon('AiSparkle2Icon', AiSparkle2IconSvg)
